import template from "./Annotator.html";

import * as util from "../util.js";

import RecogitoJS from "../js/text-annotator.umd.js";
window.process = { browser: true, env: { ENVIRONMENT: "BROWSER" } }; // Recogito needs this for some reason, idk why
const { createTextAnnotator } = RecogitoJS;
let anno = undefined;

export default {
  template: template,
  props: [
    "active_feedback",
    "hover_feedback",
    "person_id",
    "document",
    "feedbacks",
  ],

  computed: {
    selectedAnnotationID() {
      return this.active_feedback?.id || this.hover_feedback?.id;
    },
  },

  watch: {
    feedbacks: function (new_feedbacks, _old_feedback) {
      this.set_feedbacks(new_feedbacks);
    },
    active_feedback: function (new_feedback, _old_feedback) {
      if (new_feedback?.id) {
        anno.scrollIntoView(new_feedback.id);
      }
    },
    selectedAnnotationID(new_id, _old_id) {
      anno.setSelected(new_id);
    },
  },

  mounted() {
    // we need to set this manually so
    // Vue doesn't try to manage the HTML
    this.$refs.html.innerHTML = this.document.content;
    anno = createTextAnnotator(this.$refs.html, {
      user: { id: this.person_id },
    });

    anno.setStyle((_annotation, state, _zIndex) => {
      // the default style
      const style = {
        fill: "rgb(0, 128, 255)",
        fillOpacity: 0.18,
      };

      // use purple instead to make it more visible
      const selected_style = {
        fill: "rgb(128, 0, 255)",
        fillOpacity: 0.2,
      };
      return state.selected ? selected_style : style;
    });

    anno.on("clickAnnotation", (annotation) => {
      this.$emit("update:active_feedback", util.toRecord(annotation));
    });

    anno.on("createAnnotation", (annotation) => {
      annotation.id = undefined; // API should set the initial ID
      annotation.bodies = [
        {
          document_id: this.document.id,
          content: "",
        },
      ];
      this.$emit("update:active_feedback", util.toRecord(annotation));
      const annotations = this.feedbacks.map(util.fromRecord);
      anno.setAnnotations([annotation, ...annotations], (replace = true));
    });

    anno.on("selectionChanged", (annotations) => {
      const annos = this.feedbacks.map(util.fromRecord);
      anno.setAnnotations([...annos, ...annotations], (replace = true));
      if (annotations.length === 0) {
        this.$emit("update:active_feedback", undefined);
      }
    });

    this.set_feedbacks(this.feedbacks);
  },

  methods: {
    scrollTo(id) {
      anno.scrollIntoView(id);
    },
    set_feedbacks(feedbacks) {
      const annotations = feedbacks.map(util.fromRecord);
      anno.setAnnotations(annotations, (replace = true));
    },
  },
};
